import { URLS } from '@constants';

import { EAjaxFunctions, EApiUpstream } from '@enums';

import { Log, getCgiUrl } from '@utils';

import { ICountersOptions, ICountersResult, CountersResponse } from '@api';

import { BaseApi } from '../BaseApi';

import { IApiResponse } from '@interfaces';

export class CountersApi extends BaseApi {

	async getCounters(options: ICountersOptions): Promise<ICountersResult> {
		try {
			const { data: respData } = await this.fetch(options);
			const [, status,, data] = respData;
			const {
				games,
				dialogues_unread: dialogues,
				notify,
			} = data;

			if (!data || status === 'Auth') {
				throw new Error('Cant get counter!');
			}

			return {
				games,
				dialogues,
				notify,
			};
		} catch (err) {
			Log.error(`Couldn't get counters: ${err}`);
		}
	}

	protected async fetch({ user, isMobile }: ICountersOptions): Promise<IApiResponse<CountersResponse>> {
		const url = getCgiUrl({
			url: URLS.AJAX,
			params: {
				'func_name': isMobile ? EAjaxFunctions.MOB_COUNTERS : '',
				'xemail': user?.email || undefined,
				'mna': user?.magicNumber?.a || undefined,
				'mnb': user?.magicNumber?.b || undefined,
			},
		});

		return this.get({
			url,
			upstream: EApiUpstream.MPOP,
		});
	}

}
